import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'minutesAndSeconds' })
export class MinutesAndSecondsPipe implements PipeTransform {
  transform(seconds: number) {
    return Math.floor(seconds / 60) + ' Min. ' + seconds % 60 + ' Sek.';
  }
}
